import InventoryReconciliation from "models/inventory-reconciliation";
export default {
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    downExcel(id) {
      InventoryReconciliation.getExportExcel(id).then((res) => {
        let blob = new Blob([res.data], { type: res.headers.contentType });
        let fileName = window.decodeURI(
          res.headers["content-disposition"].split("=")[1]
        );
        var url = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        // 释放之前创建的URL对象
        window.URL.revokeObjectURL(url);
      });
    },
  }
}